export type ContactPayload = {
  name: string;
  email: string;
  subject: string;
  message: string;
  website?: string;
};

export type ContactResult =
  | { ok: true }
  | { ok: false; error: string };

const DEFAULT_API = process.env.REACT_APP_CONTACT_API_URL || '';

export async function sendContactMessage(payload: ContactPayload): Promise<ContactResult> {
  if (!DEFAULT_API) {
    return {
      ok: false,
      error: 'Contact API is not configured (REACT_APP_CONTACT_API_URL).',
    };
  }

  const response = await fetch(DEFAULT_API, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  let data: { ok?: boolean; error?: string } = {};
  try {
    data = await response.json();
  } catch {
    data = {};
  }

  if (!response.ok || !data.ok) {
    return {
      ok: false,
      error: data.error || `Request failed (${response.status})`,
    };
  }

  return { ok: true };
}
